<template>
  <div class="swipe_mobile">
    <van-swipe :autoplay="3000" indicator-color="white">
      <van-swipe-item v-for="(item, index) in WalkingLantern" :key="index">
        <van-image
          width="100%"
          height="100%"
          :style="{ cursor: canRouter(item) ? 'pointer' : 'unset' }"
          fit="cover"
          :src="item.advSmallimg"
          @click="chioseCarousel(item)"
        />
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import { getAdvertiseList } from "@/apis/indexPage/indexPage.js";

export default {
  name: "swipe_mobile",
  data() {
    return {
      WalkingLantern: []
    };
  },
  methods: {
    // 获取Banner
    getAdvertiseList() {
      getAdvertiseList({ position: 0 })
        .then(res => {
          //console.log("banner", res);
          if (res.code == 200) {
            let list = res.data;
            list = list.filter(item => {
              return item.advNo.indexOf("APP") !== 0
            })
            this.WalkingLantern = list;
          } else {
            this.$notify.error({
              title: "异常",
              message: res.msg
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 判断banner是否能跳转
    canRouter(item) {
      let flag = false;
      if (item.advType == 1) {
        flag = true;
      } else if (item.advType == 2) {
        flag = true;
      } else if (item.advType == 3 && item.advSeco != 0) {
        flag = true;
      } else if (item.advType == 0 && item.advSeco != 0 && item.advErtinfo) {
        flag = true;
      }
      return flag;
    },

    // 点击banner
    chioseCarousel(item) {
      if (item.advType == 1) {
        this.$router.push({
          name: "mobile_products",
          params: { no: item.classNo }
        });
      } else if (item.advType == 2) {
        this.$router.push({
          name: "mobile_productInfo",
          params: { goodsNo: item.goodsNo }
        });
      } else if (item.advType == 3 && item.advSeco != 0) {
        this.toNewPage(item.advInoutUrl);
      } else if (item.advType == 0 && item.advSeco != 0 && item.advErtinfo) {
        this.$router.push({
          name: "mobile_bannerContent",
          params: {
            advNo: item.advNo
          },
          query: {
            name: this.$route.meta.name,
            pName: this.$route.path
          }
        });
      }
    },

    toNewPage(url) {
      window.open(url);
    }
  },
  mounted() {},
  created() {
    this.getAdvertiseList();
  },
  watch: {},
  destroyed() {}
};
</script>
<style lang="less" scoped>
.swipe_mobile {
}
</style>



// WEBPACK FOOTER //
// src/viewsMobile/components/mySwipeBox/index.vue